// extracted by mini-css-extract-plugin
export var askAiIcon = "_o2-j";
export var category = "_o2-9";
export var categoryHeader = "_o2-e";
export var container = "_o2-0";
export var group = "_o2-a";
export var groupItems = "_o2-f";
export var groupSeparator = "_o2-k";
export var loading = "_o2-1";
export var noResults = "_o2-3";
export var placeholder = "_o2-2";
export var resultContent = "_o2-5";
export var resultIcon = "_o2-c";
export var resultItem = "_o2-g";
export var resultMeta = "_o2-8";
export var resultSubtitle = "_o2-7";
export var resultSuffix = "_o2-i";
export var resultTitle = "_o2-6";
export var resultsList = "_o2-4";
export var searchGroup = "_o2-d";
export var selected = "_o2-h";
export var subgroup = "_o2-b";